import { h } from '@stencil/core';
import { MAX_IMG_LIMIT, isAnalyticsEnabled, send, clickExternalPartnerLinkEvent, } from '@pes-ui/utils';
import cn from 'classnames';
import { isMobile } from '../../../../globals/utils';
export class ProductAwardsCarousel {
  constructor() {
    this.awards = undefined;
    this.isMobile = isMobile();
  }
  resizeWindowHandler() {
    this.isMobile = isMobile();
  }
  dispatchExternalPartnerUrlGAEvent(link) {
    if (isAnalyticsEnabled()) {
      const externalPartnerName = 'Awards';
      send(clickExternalPartnerLinkEvent, {
        external_partner_url: link,
        external_partner_name: externalPartnerName,
      });
    }
    window.open(link, '_blank');
  }
  render() {
    var _a, _b;
    const numberOfAwards = (_a = this.awards) === null || _a === void 0 ? void 0 : _a.length;
    return (h("se-carousel", { pagination: numberOfAwards > MAX_IMG_LIMIT || this.isMobile, arrowsOverlay: false, "item-min-width": 0, "hint-width": 0 }, (_b = this.awards) === null || _b === void 0 ? void 0 : _b.map((award) => {
      const { url, name } = award;
      const isUrlAvailable = !!url;
      return (h("se-carousel-item", { key: name, class: cn(numberOfAwards === 1 && 'product-awards-img-lg', numberOfAwards === 2 && 'product-awards-img-md', numberOfAwards >= MAX_IMG_LIMIT && 'product-awards-img-sm'), onClick: () => isUrlAvailable && this.dispatchExternalPartnerUrlGAEvent(url) }, h("pes-awards-carousel-card-content", { award: award, numberOfAwards: numberOfAwards })));
    })));
  }
  static get is() { return "pes-awards-carousel"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["awards-carousel.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["awards-carousel.css"]
    };
  }
  static get properties() {
    return {
      "awards": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductAward[]",
          "resolved": "TProductAward[]",
          "references": {
            "TProductAward": {
              "location": "import",
              "path": "../../specifications/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "isMobile": {}
    };
  }
  static get listeners() {
    return [{
        "name": "resize",
        "method": "resizeWindowHandler",
        "target": "window",
        "capture": false,
        "passive": true
      }];
  }
}
